export default {"src":"/login-app/[GIT_HASH]/_next/static/media/offline.2341e38e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};